import React from 'react';
import { FaApple, FaGlobe } from 'react-icons/fa';
import './HeroSection.css';

const HeroSection = () => {
    return (
        <section className="hero">
            <div className="hero-content container">
                <h1 className="hero-title">Jeledi</h1>
                <h2 className="hero-slogan">Le réseau social basé entièrement sur la voix</h2>
                <p className="hero-text">
                    Jeledi est un réseau social basé entièrement sur la voix.
                    Ici, pas de longues publications à rédiger ni de filtres compliqués : tu ouvres ton micro et tu t’exprimes librement.
                    Partage tes pensées, raconte ton quotidien, lance un débat ou envoie un message vocal spontané à tes amis et à tes followers : tout se fait avec ta voix.
                </p>
                <div className="hero-buttons">
                    <a href="https:/jeledi.empirano.com" className="btn btn-primary store-btn">
                        <FaApple className="btn-icon" />
                        <span>App Store</span>
                    </a>
                    <a href="https://empirano.com" target="_blank" rel="noopener noreferrer" className="btn btn-secondary web-btn">
                        <FaGlobe className="btn-icon" />
                        <span>Empirano.com</span>
                    </a>
                </div>
            </div>
            {/* Abstract background element could go here */}
            <div className="hero-bg-accent"></div>
        </section>
    );
};

export default HeroSection;
